import { useState } from 'react'

import { MonthSelect } from '../../DateTime'
import { Component, ComponentProps } from '../Component'
import { controls, month, numberSize } from '../Controls'

export function MonthSelectUsage() {
  const [props, setProps] = useState(() =>
    controls() //
      .add(numberSize('size'))
      .add(month('maxValue', null))
      .add(month('minValue', null))
      .add(month('value', null))
  )

  function handleChange(nextYear) {
    setProps(controls => controls.setValue('value', nextYear))
  }

  return (
    <>
      <Component
        {...props.getValues()}
        Component={MonthSelect}
        name='MonthSelect'
        style={{ width: 240 }}
        onChange={handleChange}
      />
      <ComponentProps name='MonthSelect' value={props} onChange={setProps} />
    </>
  )
}
